export const defaultValues = {
    "freq": "",
    "agc": "off",
    "amplitude": "no",
    "normalise": "yes",
    "functional": "2NRM",
}